import { ActivatedRoute, Router } from '@angular/router';
import { ServicesSunsetService } from './../services-sunset.service';
import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { CierreAdm, Empresa } from '../configuracion/configuracion.entity';

@Component({
  selector: 'app-seleccionar-empresa',
  templateUrl: './seleccionar-empresa.component.html',
  styleUrls: ['../../app.component.css']
})
export class SeleccionarEmpresaComponent implements OnInit {

  rutaUrl: string = '';
  empresas: Empresa[] = [];
  empresa: Empresa = new Empresa();
  cierresAdm: CierreAdm[] = [];
  @Output() emitSalida: EventEmitter<boolean>;
  @Input() volverHome: number =0;
  constructor(private _servicios:ServicesSunsetService, private route: Router, private router: ActivatedRoute) {

    this.emitSalida = new EventEmitter();

  }

  async ngOnInit() {

    this.cierresAdm = [];
   console.log('Configuración inicial');
   await this.configuracionInicial();
   console.log('Cargar Empresa');
   await this.cargarEmpresa();

  }


 async configuracionInicial() {


  await  this._servicios.Configuracion().subscribe(

      (data: any) => {


        this.rutaUrl = data.rutaimagen;

      }

    );

  }

  async seleccionar(empresa: Empresa) {

    const salir = false;

    var fecha = new Date();
  
    sessionStorage.setItem('idd', empresa.emp_idd);

    await  this._servicios.MostrarEmpresa().subscribe(

      (data: any) => {

        this.empresa = data.consulta[0];
        this.cierresAdm = data.cierre;

        
        sessionStorage.setItem('empresa', JSON.stringify(this.empresa) );
        sessionStorage.setItem('cierreadm', JSON.stringify(this.cierresAdm) );
        // JSON.stringify(empresa)
        this.route.navigate(['/home'], { relativeTo: this.router});
        this.emitSalida.emit(salir);

      }

    );


  }

  cargarEmpresa() {

    this.empresa = new Empresa();
    this.empresas = [];

    this._servicios.seleccionarEmpresa(sessionStorage.getItem('correo') || '').subscribe(

      (data: any) => {

        this.empresas = data.empresa;

      }

    );

  }

}
